
import { defineComponent, computed} from "vue";
import { useStore} from "vuex";

export default defineComponent ({
  name: "noData",
  setup(){
    const store = useStore();
    let wxModelShow = computed( ()=>{
      return store.state.classPurchase.wxModelShow
    })
    const handleClose = ():void =>{
      store.dispatch('handleSetGainClassShow' , false)
    }
    return{
      wxModelShow,
      handleClose
    }
  }
})
